var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4285 6.48193H3.58928C2.4354 6.48193 1.5 7.41734 1.5 8.57122V20.4105C1.5 21.5643 2.4354 22.4998 3.58928 22.4998H15.4285C16.5824 22.4998 17.5178 21.5643 17.5178 20.4105V8.57122C17.5178 7.41734 16.5824 6.48193 15.4285 6.48193ZM16.125 20.4105C16.125 20.7951 15.8132 21.107 15.4285 21.107H3.58928C3.20464 21.107 2.89284 20.7951 2.89284 20.4105V8.57122C2.89284 8.18658 3.20464 7.87478 3.58928 7.87478H15.4285C15.8132 7.87478 16.125 8.18658 16.125 8.57122V20.4105Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9111 3H6.37542C5.22154 3 4.28613 3.9354 4.28613 5.08928C4.28613 5.47392 4.59793 5.78572 4.98257 5.78572C5.36721 5.78572 5.67897 5.47392 5.67897 5.08928C5.67897 4.70464 5.99078 4.39284 6.37542 4.39284H18.9111C19.2957 4.39284 19.6076 4.70464 19.6076 5.08928V17.625C19.6076 18.0096 19.2957 18.3214 18.9111 18.3214C18.5265 18.3214 18.2147 18.6332 18.2147 19.0179C18.2147 19.4025 18.5265 19.7143 18.9111 19.7143C20.065 19.7143 21.0004 18.7789 21.0004 17.625V5.08928C21.0004 3.9354 20.065 3 18.9111 3Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.5f23378fbaf9dbf4ddc723104d6f963a.svg";
export { ForwardRef as ReactComponent };